export default __webpack_public_path__ + "static/media/layout-1 (1).cb82812f.jpg";